import React, { useState } from "react";
import { useDispatch } from "react-redux";
import GoogleIcon from "../../assets/images/icons/socials/google.svg";
import FacebookIcon from "../../assets/images/icons/socials/facebook.svg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getOAuthURL, openOAuthPopup, handleOAuthCallback } from "../../utils/oauth.utils";
import { handleOAuthSuccess, setOAuthLoading } from "../../redux/authSlice";

const SignInFooter = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [oauthProvider, setOauthProvider] = useState(null);

  const handleSignUpClick = () => {
    navigate("/signUp");
  };

  const handleOAuthLogin = async (provider) => {
    try {
      setOauthProvider(provider);
      dispatch(setOAuthLoading(true));

      // USER için OAuth URL
      const oauthUrl = getOAuthURL(provider, 'user');
      const popup = openOAuthPopup(oauthUrl, `${provider}_user_login`);

      if (!popup) {
        throw new Error('Popup was blocked. Please disable your popup blocker and try again.');
      }

      // Popup'ın kapanmasını bekle
      const clearLoadingState = () => {
        dispatch(setOAuthLoading(false));
        setOauthProvider(null);
      };

      const checkClosed = setInterval(() => {
        let isClosed = false;

        try {
          isClosed = !popup || popup.closed;
        } catch (err) {
          console.warn("Unable to verify OAuth popup state due to browser policy:", err);
          isClosed = true;
        }

        if (isClosed) {
          clearInterval(checkClosed);
          clearLoadingState();
        }
      }, 1000);

      // OAuth callback'ini bekle
      const result = await handleOAuthCallback();
      clearInterval(checkClosed);
      try {
        popup?.close();
      } catch (err) {
        console.warn("Unable to close OAuth popup:", err);
      }

      if (result.type === 'OAUTH_SUCCESS') {
        const { token, role } = result;
        
        // USER için success handler
        await dispatch(handleOAuthSuccess({ token, role })).unwrap();
        navigate('/userHomePage');
      }
    } catch (error) {
      console.error('User OAuth error:', error);
      alert(error.message || 'Sign-in failed');
    } finally {
      dispatch(setOAuthLoading(false));
      setOauthProvider(null);
    }
  };

  return (
    <>
      <div className="flex items-center my-4">
        <hr className="flex-grow border-text" />
        <span className="mx-4 text-text text-[15px] font-poppins">{t("or")}</span>
        <hr className="flex-grow border-text" />
      </div>

      <div className="flex justify-center space-x-[48px]">
        <div className="relative">
          <img 
            src={GoogleIcon} 
            alt="Google" 
            className={`w-[55px] h-[55px] cursor-pointer transition-opacity ${
              oauthProvider === 'google' ? 'opacity-50' : 'hover:opacity-80'
            }`}
            onClick={() => handleOAuthLogin('google')}
          />
          {oauthProvider === 'google' && (
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin"></div>
            </div>
          )}
        </div>
        
        <div className="relative">
          <img
            src={FacebookIcon}
            alt="Facebook"
            className={`w-[55px] h-[55px] cursor-pointer transition-opacity ${
              oauthProvider === 'facebook' ? 'opacity-50' : 'hover:opacity-80'
            }`}
            onClick={() => handleOAuthLogin('facebook')}
          />
          {oauthProvider === 'facebook' && (
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin"></div>
            </div>
          )}
        </div>
      </div>

      <p className="text-center text-[15px] text-text mt-6 font-poppins">
        {t("signupQuestion")} {" "}
        <span
          onClick={handleSignUpClick}
          className="ml-6 font-poppins font-[700] text-text cursor-pointer"
        >
          {t("signUp")}
        </span>
      </p>
    </>
  );
};

export default SignInFooter;
